module.exports = __webpack_public_path__ + "images/royal-canin.sprite-brand3-xs.c3ee11f399a8b2c2398eeb7c44ea248d.svg";